import { createAsyncThunk } from "@reduxjs/toolkit";
import { memberApi } from "api/member";
import { MemberPayload } from "types/member";

export const getMemberVip = createAsyncThunk(
  "member/getVipMember",
  async (data: MemberPayload, { rejectWithValue }) => {
    try {
      const response = await memberApi.getMemberVip(data.username, data);
      return response;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);
